import { render, staticRenderFns } from "./questionnaireList.vue?vue&type=template&id=47590d36&scoped=true&"
import script from "./questionnaireList.vue?vue&type=script&lang=js&"
export * from "./questionnaireList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47590d36",
  null
  
)

export default component.exports